import cn from "classnames";
import Link from "next/link";
import React from "react";

export default function InternalLink({
  href,
  variant = "blue",
  className,
  children,
  tag = "link", // new prop to determine the tag type
  ...props
}) {
  const commonClasses = cn(
    {
      "text-white hover:text-blue hover:bg-white bg-lightBlue":
        variant === "lightBlue",
      "text-white hover:text-white hover:bg-lightBlue bg-blue":
        variant === "darkBlue",
      "text-white bg-lightBlue hover:bg-blue": variant === "lightBlueInverted",
      "text-whit hover:text-white hover:bg-white bg-[#dd5324]":
        variant === "red",
      "text-white hover:text-black bg-transparent hover:bg-white border-white":
        variant === "whiteOutline",
      "text-white bg-green hover:bg-blue hover:border-blue border-green":
        variant === "green",
      "text-white bg-green border-green": variant === "greenSolid",
      "text-black hover:text-white bg-white hover:bg-green hover:border-green border-green":
        variant === "greenOutline",
    },
    className,
    "w-fit rounded-[10px] md:py-3 py-3 md:px-6 px-2 text-center capitalize font-work md:text-base text-xs transition-all duration-300 ease cursor-pointer"
  );

  if (tag === "div") {
    return (
      <div {...props} className={commonClasses}>
        {children}
      </div>
    );
  }

  return (
    <Link href={href} className={commonClasses}>
      {children}
    </Link>
  );
}
